import React, { useState, useReducer } from 'react'
import * as yup from "yup"
import { Form, Formik } from 'formik';
import Modal from 'react-bootstrap/Modal';
import { formInitialState, formReducer } from '../../../../../reducers/formReducer';
import FormErrorMessage from '../../../../UI/errorMessages/FormErrorMessage';
import CMSFormTextArea from '../../../../UI/forms/CMSFormTextArea';
import { Button, Card, Col, Row } from 'react-bootstrap';
import axios from "../../../../../config/axios";
import { Store as toast } from 'react-notifications-component';
import { toastNotification } from '../../../../../config/toastNotification'
import CMSFormInput from '../../../../UI/forms/CMSFormInput';
import CMSFormCheckBoxes from '../../../../UI/forms/CMSFormCheckBoxes';
import { getFullName, getNotConfirmedGuestCount, getNotConfirmedKidsCount, getRemainingGuestCount, getRemainingKidsCount } from '../../../../../helpers/CommonHelper';
import ModuleDisplayDate from '../../../../UI/modules/fieldsDisplay/ModuleDisplayDate';

export const AdditionalRequestAcceptModal = ({ show, setShow, loadItems, item }) => {
    const [formState, formDispatch] = useReducer(formReducer, formInitialState)
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const onSubmit = async (data, resetForm) => {

        formDispatch({
            type: "FORM_SUBMISSION_REQUEST"
        });

        try {
            const res = await axios.post(`activity-registrations/accept-additional-request`, data);
            formDispatch({
                type: "FORM_SUBMISSION_SUCCESS",
                payload: res.data
            });
            handleClose()
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `Action done successfully.`,
                type: "success",
            });
            resetForm();
            formDispatch({
                type: "FORM_INITIAL_STAGE"
            });
            loadItems()
        } catch (error) {
            formDispatch({
                type: "FORM_SUBMISSION_FAILED",
                payload: error
            });

            setTimeout(() => {
                formDispatch({
                    type: "FORM_INITIAL_STAGE"
                });
            }, 5000)
        }
    }

    const getValidationSchema = () => {
        return yup.object({
            allowedNumberGuests: yup.number().required("Enter allowed number of guests."),
            allowedNumberKids: yup.number().required("Enter allowed number of kids."),
            comments: yup.string().max(200),
            notes: yup.string().max(200),
            paidAmount: yup
                .number()
                // .transform((cv) => (isNaN(cv) ? undefined : cv))
                // .integer()
                .required("Enter Payable amount."),

        })
    }

    const getInitialValues = () => {

        let returnObj = {
            id: item._id,
            allowedNumberGuests: item.NumberOfGuestParticipating,
            allowedNumberKids: item.NumberOfKidsParticipating,
            totalAmount: item.payment.totalAmount,
            comments: item.adminCommentsForMember,
            notes: item.adminNotesForReference,
            paidAmount: item.payment.paidAmount ? item.payment.paidAmount : item.payment.totalAmount,
        }
        return returnObj;
    }

    return (


        <Formik
            initialValues={getInitialValues()}
            validationSchema={getValidationSchema()}
            enableReinitialize={true}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={async (values, { resetForm }) => {
                console.log(values);
                onSubmit(values, resetForm)
            }}
        >
            {(form) => (

                <Modal className='acceptModal' show={show} onHide={handleClose}>
                    {(formState.isFormSubmitting) && <div class="overlay">
                        <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
                    </div>}
                    {/* {(formState.isFormSubmitting) && <ContainerLoading />} */}
                    <Form onSubmit={form.handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>Accept Additional Request</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>

                            {(formState.hasSubmissionError) &&
                                <FormErrorMessage error={formState.formSubmissionError} />
                            }


                            <div className="fixedDetails borderDashedBottom">
                                <div className="memberName">{item.member.fullName}</div>
                                <div className="activityTitle mx-0">{item.activity.title}</div>
                                <div className="activityLocation mx-0">{item.activity.location}</div>
                                <div className="activityDate mx-0"><ModuleDisplayDate value={item.activity.date} /></div>
                            </div>

                            <Row className='w-100 mx-auto mt-3'>
                                <Col className='d-flex flex-column justify-content-start'>
                                    {
                                        (
                                            (item.activity.guestFeaturesSettings && item.activity.guestFeaturesSettings.allowed === "1" && item.guestParticipating !== '1') ||
                                            (item.activity.kidsFeaturesSettings && item.activity.kidsFeaturesSettings.allowed === "1" && item.kidsParticipating !== '1') ||
                                            (item.activity.guestFeaturesSettings && item.activity.guestFeaturesSettings.allowed !== "1") ||
                                            (item.activity.kidsFeaturesSettings && item.activity.kidsFeaturesSettings.allowed !== "1")
                                        ) && (
                                            <div className="alertNotApplicable fontItalic">
                                                {
                                                    (item.activity.guestFeaturesSettings && item.activity.guestFeaturesSettings.allowed === "1")
                                                        ? (
                                                            (item.guestParticipating === '1')
                                                                ? null
                                                                : <p className='mb-0'>Guest participation is not requested</p>
                                                        )
                                                        : <p className='mb-0'>Guests are not allowed in this activity</p>
                                                }

                                                {
                                                    (item.activity.kidsFeaturesSettings && item.activity.kidsFeaturesSettings.allowed === "1")
                                                        ? (
                                                            (item.kidsParticipating === '1')
                                                                ? null
                                                                : <p className='mb-0'>Kids participation is not requested.</p>
                                                        )
                                                        : <p className='mb-0'>Kids are not allowed in this activity</p>
                                                }
                                            </div>
                                        )
                                    }
                                    {
                                        (item.activity.guestFeaturesSettings && item.activity.guestFeaturesSettings.allowed === "1" && item.guestParticipating === "1")
                                            ? <Card>
                                                <Card.Body className='py-1 px-3'>


                                                    {
                                                        (item.guestParticipating === '1')
                                                            ? <>

                                                                <div className="fontItalic"> Guest participation requested for <b>{item.NumberOfGuestParticipating}</b>  person </div>
                                                                <div className="mb-3 fontItalic ">Guest participation fee: <b>{item.activity.guestFeaturesSettings.participationFee} AED</b> </div>
                                                                <CMSFormInput
                                                                    name="allowedNumberGuests"
                                                                    label="Allowed Number of Guests"
                                                                    required={true}
                                                                    form={form}
                                                                    type="number"
                                                                    maxNumber={getNotConfirmedGuestCount(item.activity, item)}
                                                                />
                                                            </>
                                                            : null
                                                    }
                                                </Card.Body>
                                            </Card>
                                            : null
                                    }

                                    {
                                        (item.activity.kidsFeaturesSettings && item.activity.kidsFeaturesSettings.allowed === "1" && item.kidsParticipating === "1")
                                            ? <Card>
                                                <Card.Body className='py-1 px-3'>
                                                    {
                                                        (item.kidsParticipating === '1')
                                                            ? <>
                                                                <div className="fontItalic">Kids participation requested for {item.reqNumberOfKidsParticipating} person</div>
                                                                <div className="fontItalic mb-3 ">Kids participation fee {item.activity.kidsFeaturesSettings.participationFee} AED</div>
                                                                <CMSFormInput
                                                                    name="allowedNumberKids"
                                                                    label="Allowed Number of Kids"
                                                                    required={true}
                                                                    form={form}
                                                                    type="number"
                                                                    maxNumber={getNotConfirmedKidsCount(item.activity, item)}
                                                                />
                                                            </>
                                                            : null
                                                    }
                                                </Card.Body>
                                            </Card>
                                            : null
                                    }

                                </Col>
                                <Col>
                                    <CMSFormInput
                                        name="totalAmount"
                                        label="Total Amount (System Calculated)"
                                        required={false}
                                        form={form}
                                        disabled={true}
                                    />




                                    <CMSFormInput
                                        name="paidAmount"
                                        label="Payable Amount"
                                        required={true}
                                        form={form}
                                        type="number"
                                    />






                                    <CMSFormTextArea
                                        name="comments"
                                        label="Comments For Member"
                                        form={form}
                                        required={false}
                                    />

                                    <CMSFormTextArea
                                        name="notes"
                                        label="Notes For Admin Records"
                                        form={form}
                                        required={false}
                                    />



                                </Col>
                            </Row>


















                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" type="submit">
                                Submit
                            </Button>


                        </Modal.Footer>


                    </Form>


                </Modal>

            )}
        </Formik>
    )
}
